export const Get_BussinessUsers = "Get_BussinessUsers";
export const Get_BussinessUsersById = "Get_BussinessUsersById";
export const post_SignUp_BussinessUsers = "post_SignUp_BussinessUsers";
export const post_Login_BussinessUsers = "post_Login_BussinessUsers";
export const Get_Countries = "Get_Countries";
export const Edit_BussinessUsers = "Edit_BussinessUsers";
export const post_SignUp_VolunteerUsers = "post_SignUp_VolunteerUsers";
export const post_Login_VolunteerUsers = "post_Login_VolunteerUsers";
export const Get_VolunteerUsers = "Get_VolunteerUsers";
export const Edit_VolunteerUsers = "Edit_VolunteerUsers";
export const Get_VolunteerById = "Get_VolunteerById";
export const Get_timeDurationTypes = "Get_timeDurationTypes";
export const Get_Jobs = "Get_Jobs";
export const ADD_Job = "ADD_Job";
export const Delete_Job = "Delete_Job";
export const Edit_Job = "Edit_Job";
// export const ADD_Task = "ADD_Task";
export const GET_Error = "GET_Error";
/////business owner personal info
export const GET_OwnerUsers = "GET_OwnerUsers";
export const GET_OwnerUser = "GET_OwnerUser";
export const ADD_OwnerUser = "ADD_OwnerUser";
export const EDIT_OwnerUser = "EDIT_OwnerUser";
export const DELETE_OwnerUser = "DELETE_OwnerUser";
/////////Malak Start SKILLS//////
export const ADD_SKILL = "ADD_SKILL";
export const ADD_SKILL__SEC_UPDATE = " ADD_SKILL__SEC_UPDATE";
export const GET_SKILL_BY_ID = " GET_SKILL_BY_ID";
export const GET_SKILL_USER_SKILLS = "GET_SKILL_USER_SKILLS";
export const GET_Array_OF_SKILLS = "GET_Array_OF_SKILLS";
export const EDIT_SKILL = "EDIT_SKILL";
export const DELETE_SKILL = "DELETE_SKILL";

export const GET_TASK_BY_ID = "GET_TASK_BY_ID";
export const ADD_NEW_TASK = "ADD_NEW_TASK";
export const GET_VOL_TASKS = "GET_VOL_TASKS";

export const ADD_FEEDBACK = "ADD_FEEDBACK";
export const GET_FEEDBACK = "GET_FEEDBACK";
/////////Malak End SKILLS//////

////////////////////////education///////////////

export const ADD_EDUCATION = "ADD_EDUCATION";
export const REMOVE_EDU = "REMOVE_EDU";
export const GET_EDU = "GET_EDU";
export const EDIT_EDUCATION = "EDIT_EDUCATION";

///////////////////////Comments/////////////////////////
export const ADD_COMMENT = "ADD_COMMENT";
export const REMOVE_COMMENT = "REMOVE_COMMENT";
export const GET_COMMENT = "GET_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
/////////////////upload task part//////////////////////////
export const ADD_SUBMITTASK_LINK ="ADD_SUBMITTASK_LINK";
export const GET_ALLSUBMITTED_TASKS ="GET_ALLSUBMITTED_TASKS";
////////////when upload task delete it from my progress//////////////
export const DELET_TASKFROM_PROGRESS="DELET_TASKFROM_PROGRESS";

